"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Whisper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Whisper_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -1,
    width: 14,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.866.014a.5.5 0 0 0-.232.972c1.7.406 2.098 1.85 2.098 2.762 0 .678.325 1.462.812 2.25.485.784 1.117 1.55 1.701 2.187.319.348.307.82.14 1.202-.166.38-.515.742-.983.846a.675.675 0 0 0-.527.661v1.21c0 .392-.101.868-.25 1.29-.144.415-.348.82-.58 1.042-.367.35-1.02.542-1.696.562-.687.02-1.454-.133-2.08-.531a.5.5 0 1 0-.537.843c.832.53 1.807.713 2.646.688.788-.024 1.733-.243 2.357-.839.41-.39.677-.983.835-1.434.171-.49.305-1.083.305-1.621v-.967c.707-.247 1.191-.81 1.427-1.35.26-.597.36-1.536-.32-2.278-.562-.613-1.149-1.327-1.587-2.037-.458-.74-.663-1.329-.663-1.724 0-1.121-.509-3.172-2.866-3.734Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.454 9.557a.5.5 0 0 1 .665.24 4 4 0 0 1-.257 3.87.5.5 0 0 1-.84-.541 3.001 3.001 0 0 0 .192-2.903.5.5 0 0 1 .24-.666ZM13.832 8.516a.5.5 0 0 0-.905.426 6 6 0 0 1-.378 5.8.5.5 0 0 0 .841.54 7 7 0 0 0 .442-6.766Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Whisper_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Whisper;
exports["default"] = _default;